export class EmployeeCodeRequest {
    employeeCode: string;

    constructor(employeeCode: string) {
        this.employeeCode = employeeCode;
    }
}